const pick = (value: unknown, fallback: unknown) => {
    if (value === undefined || value === null || value === '') {
        return fallback;
    }
    return value;
};

export function mergeLoginSession(currentUser: any, updated: any) {
    if (!currentUser) {
        return null;
    }

    return {
        jwtToken: currentUser.jwtToken,
        hash: pick(updated?.hash, currentUser.hash),
        userName: pick(updated?.userName, currentUser.userName),
        userId: updated?.userId ?? currentUser.userId,
        lastName: pick(updated?.lastName, currentUser.lastName),
        firstName: pick(updated?.firstName, currentUser.firstName),
        middleName: pick(updated?.middleName, currentUser.middleName),
        email: pick(updated?.email, currentUser.email),
        theme: pick(updated?.theme, currentUser.theme),
        phoneNo: pick(updated?.phoneNo, currentUser.phoneNo),
        pass: currentUser.pass ?? null,
        isValidPassword: currentUser.isValidPassword ?? true,
    };
}

export function readStoredLoginSnapshot(): any | null {
    try {
        const raw = localStorage.getItem('callcenter:user');
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
        return null;
    }
}

export function writeStoredLoginSnapshot(sessionUser: any) {
    if (!sessionUser?.userId && !sessionUser?.userName) {
        return;
    }

    const previous = readStoredLoginSnapshot();
    const sameUser = !previous?.userId || !sessionUser.userId || String(previous.userId) === String(sessionUser.userId);

    localStorage.setItem('callcenter:user', JSON.stringify({
        userName: sessionUser.userName ?? null,
        userId: sessionUser.userId ?? null,
        lastName: sessionUser.lastName ?? null,
        firstName: sessionUser.firstName ?? null,
        middleName: sessionUser.middleName ?? null,
        email: sessionUser.email ?? null,
        theme: sessionUser.theme ?? null,
        phoneNo: sessionUser.phoneNo ?? null,
        hash: sessionUser.hash || (sameUser ? previous?.hash : null) || null,
        isValidPassword: sessionUser.isValidPassword ?? true,
    }));
}

export function restoreLoginSession(currentUser: any) {
    if (!currentUser?.jwtToken?.jwtToken || !currentUser?.userId || currentUser?.hash) {
        return null;
    }

    const stored = readStoredLoginSnapshot();
    if (!stored?.hash) {
        return null;
    }
    if (stored.userId && String(stored.userId) !== String(currentUser.userId)) {
        return null;
    }

    return mergeLoginSession(currentUser, {
        hash: stored.hash,
        userName: currentUser.userName || stored.userName,
    });
}
